/**
 * @generated SignedSource<<b638a2e66d8833ba4d2fa0284af21ce3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FocusUnitQuery$variables = {
  targetId: string;
};
export type FocusUnitQuery$data = {
  readonly target: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly targetGroup: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly targetSkills: ReadonlyArray<{
      readonly skill: {
        readonly id: string;
      } | null | undefined;
      readonly targetSkillType: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type FocusUnitQuery = {
  response: FocusUnitQuery$data;
  variables: FocusUnitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "isActive": "ACTIVE"
    }
  },
  {
    "kind": "Literal",
    "name": "targetGroupFilter",
    "value": {
      "isActive": "BOTH"
    }
  },
  {
    "kind": "Variable",
    "name": "targetId",
    "variableName": "targetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusUnitQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillTypeNode",
                "kind": "LinkedField",
                "name": "targetSkillType",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusUnitQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillTypeNode",
                "kind": "LinkedField",
                "name": "targetSkillType",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "612fe0b21d19211c94f800f4b96fa9fb",
    "id": null,
    "metadata": {},
    "name": "FocusUnitQuery",
    "operationKind": "query",
    "text": "query FocusUnitQuery(\n  $targetId: ID!\n) {\n  target(targetId: $targetId, filter: {isActive: ACTIVE}, targetGroupFilter: {isActive: BOTH}) {\n    id\n    name\n    targetGroup {\n      name\n      id\n    }\n    targetSkills {\n      targetSkillType {\n        name\n        id\n      }\n      skill {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6efd8a7843309c75f749b7946cfc23cd";

export default node;
